import RadioButtonQuest from "../../../../UI/RadioButtonQuest";

const StruggledRepayments = ({
  onSelectAnswer,
  backClick,
  strugleRepaymentsBck,
  clsName,
}) => {
  const optionHandle = async (e) => {
    if (e.target.value === "286") {
      onSelectAnswer(e);
    } else if (e.target.value === "287") {
      onSelectAnswer(e);
    }
  };

  let toggle;
  if (strugleRepaymentsBck == "313") {
    toggle = "didtakefurtherborrowing";
  } else if (strugleRepaymentsBck == "312") {
    toggle = "furtherborrowing";
  }
  return (
    <div className={`qsSlider slidea5 ${clsName}`}>
      <h2 className="qs-title slide-up-now">
        {" "}
        Did you struggle to meet your essential repayments while being in your
        overdraft?
      </h2>
      <ul className="btn-option optinal-items  two-options  slide-up-now">
        <li>
          <div className=" option_but ">
            <RadioButtonQuest
              key="strrep1"
              className="radio"
              labelName="Yes"
              labelClassName="align-items-center justify-content-center btn-next next5"
              onClick={optionHandle}
              value="286"
              name="struggledRepayments"
              id="strrep1"
              dataQuestId={103}
              dataAnsId={286}
              dataAnsLabel="Yes"
            />
          </div>
        </li>
        <li>
          <div className="option_but btn-next ">
            <RadioButtonQuest
              key="strrep2"
              className="radio"
              labelName="No"
              labelClassName="align-items-center justify-content-center btn-next next5"
              onClick={optionHandle}
              value="287"
              name="struggledRepayments"
              id="strrep2"
              dataQuestId={103}
              dataAnsId={287}
              dataAnsLabel="No"
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default StruggledRepayments;
